import { FC, forwardRef, useContext, useImperativeHandle, useState } from 'react';
import dayjs from 'dayjs';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import { contrast, isNotEmpty } from '@lhb/func';
import { globalFranchiseeAlias, showInvalidFieldMsg } from '@/common/utils/ways';
import { getClusterAndDirectTaskDetail, postTaskUpdate } from '@/common/api/expandStore/clusterAndDirect';
import { BusinessMode, franchiseeShortTitleForMode, TaskStatus } from '@/common/components/business/ExpandStore/ts-config';
import { FollowingStatus } from '@/views/expandstore/pages/expansioncirclesenmatask/ts-config';
import UserInfoContext from '@/layout/context';
import styles from './index.module.less';
import { Col, Form, Modal, Row } from 'antd';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import V2Form from '@/common/components/Form/V2Form';
import V2FormDatePicker from '@/common/components/Form/V2FormDatePicker/V2FormDatePicker';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import FormManager from 'src/views/expandstore/pages/expansionFranchiseeCircleTask/components/FormManager';
import FormBusinessMode from 'src/views/expandstore/pages/expansionFranchiseeCircleTask/components/FormBusinessMode';
import FormEmergencyDegree from 'src/views/expandstore/pages/expansionFranchiseeCircleTask/components/FormEmergencyDegree';
import FormFranchisee from '@/common/components/Form/bussiness/FormFranchisee';
import FormFollowingStatus from 'src/views/expandstore/pages/expansionFranchiseeCircleTask/components/FormFollowingStatus';

/**
 * 拓店任务-部分字段编辑
 * @Description 加盟+直营A（基诺浦）、加盟+直营B（一鸣）
 * // TODO 接口未提供 manager；传 null 时，接口不正常保存值
 */
const CircleTaskCreateDrawer: FC<{
  /** 提交表单后的回调 */
  onRefresh?: ()=>void,
  ref?: any,
}> = forwardRef(({
  onRefresh,
}, ref) => {

  useImperativeHandle(ref, () => ({
    init: methods.init,
  }));

  const {
    // /** 当前租户的拓店任务模板是否“加盟+直营A（基诺浦）”，未确定时为null */
    // isStandardAndClusterATaskTemplate,
    /** 当前租户的拓店任务模板是否“加盟+直营B（一鸣）”，未确定时为null */
    isStandardAndClusterBTaskTemplate,
  } = useTenantCheckInfo();

  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const franchiseeAlias = globalFranchiseeAlias(globalAliasItemVOs);

  const [taskId, setTaskId] = useState<any>(null);
  const [taskDetail, setTaskDetail] = useState<any>({});
  const [form] = Form.useForm();
  const [requesting, setRequesting] = useState(false);
  // const [selection, setSelection] = useState<{
  //   /** 紧急程度 */
  //   emergencyOptions: any[],
  //   /** 踩点紧急度 */
  //   emergencyDegreeBySpotSurvey: any[],
  //   /** 备选点上传紧急度 */
  //   emergencyDegreeByChancePoint: any[],
  //  }>({ emergencyOptions: [], emergencyDegreeBySpotSurvey: [], emergencyDegreeByChancePoint: [] });

  const [visible, setVisible] = useState(false);

  const businessMode = Form.useWatch('businessMode', form);
  /**
   * @description 加盟商字段标题
   * @param businessMode 【加盟+直营】拓店任务模板场景下【业务模式】字段值
   * @return 判断是否联营模式，需要特殊显示
   */
  const franchiseeTitleForMode = businessMode === BusinessMode.Joint ? '联营商姓名' : `${franchiseeAlias}姓名`;

  /** 跟进状态是否禁用：
   * 加盟+直营A（基诺浦）-已确定、已开业
   * 加盟+直营B（一鸣）-已完成、已关闭
   * */
  const followingStatusDisabled = isStandardAndClusterBTaskTemplate
    ? [TaskStatus.Complete, TaskStatus.Closed].includes(+taskDetail?.status)
    : [FollowingStatus.Confirmed, FollowingStatus.Opened].includes(+taskDetail?.followingStatus);

  const methods = useMethods({

    init(taskId: any) {
      setTaskId(taskId);
      setVisible(true);
      setTimeout(() => {
        methods.getSelection();
        methods.loadData();
      }, 0);
    },

    /** 加载详情信息 */
    loadData() {
      if (!taskId) {
        return;
      }
      getClusterAndDirectTaskDetail({ id: taskId }).then((res) => {
        console.log('res', res);
        setTaskDetail(res);
        form.setFieldsValue({
          manager: res.manager,
          businessMode: res.businessMode,
          emergencyDegree: res.emergencyDegree,
          expectDropInDate: res.expectDropInDate ? dayjs(res.expectDropInDate).format('YYYY-MM-DD') : null,
          standardFranchiseeId: res.standardFranchiseeId,
          followingStatus: res.followingStatus,
        });
      });
    },

    /**
     * 获取下拉选项
     */
    getSelection: async () => {
      // getStandardTaskSelection().then(res => {
      //   setSelection(val => ({ ...val,
      //     emergencyOptions: refactorSelection(res.emergencyDegree),
      //     emergencyDegreeBySpotSurvey: refactorSelection(res.emergencyDegreeBySpotSurvey),
      //     emergencyDegreeByChancePoint: refactorSelection(res.emergencyDegreeByChancePoint),
      //   }));
      // });
    },

    onChangeBusinessMode() {
      form.setFieldValue('standardFranchiseeId', null);
    },

    /**
     * 提交表单
     */
    onSubmit: async():Promise<void> => {
      form.validateFields().then((values: any) => {
        // console.log('values', values);

        // TODO 接口未提供 manager；传 null 时，接口不正常保存值

        const params: any = {
          id: taskId,
          manager: contrast(values, 'manager'),
          // assignAccountIds: contrast(values, 'assignAccountIds') ? [contrast(values, 'assignAccountIds')] : [], // 未支持
          businessMode: contrast(values, 'businessMode'),
          standardFranchiseeId: isNotEmpty(values.businessMode) ? values.standardFranchiseeId : null,
          followingStatus: contrast(values, 'followingStatus'),
          expectDropInDate: contrast(values, 'expectDropInDate'),
          emergencyDegree: contrast(values, 'emergencyDegree'),
        };
        setRequesting(true);
        postTaskUpdate(params).then(() => {
          V2Message.success('编辑拓店任务成功');
          setVisible(false);
          onRefresh && onRefresh();
        }, err => {
          setVisible(false);
          console.log('catch 失败', err);
          V2Message.error('编辑拓店任务失败');
        }).finally(() => {
          setRequesting(false);
        });
      }).catch((err) => {
        err && showInvalidFieldMsg(err.errorFields, 1);
      });
    },

    onCancel: () => {
      setVisible(false);
    },

  });

  return (
    <Modal
      title='编辑拓店任务'
      open={visible}
      destroyOnClose
      confirmLoading={requesting}
      bodyStyle={{ padding: 0 }}
      className={styles.simpleEditModal}
      onOk={methods.onSubmit}
      onCancel={methods.onCancel}
      // contentWrapperStyle={{
      //   minWidth: 'auto',
      //   width: '1008px',
      // }}
    >
      <V2Form form={form} className={cs('pt-12 pb-12 pl-24 pr-24')} >
        <Row gutter={24}>
          <Col span={12}>
            {/* 待指派时才可选择开发经理 */}
            <FormManager label='开发人员' placeholder='请选择开发人员' name='manager' disabled={false && taskDetail?.status !== TaskStatus.WaitAssign} />
          </Col>
          <Col span={12}>
            <FormBusinessMode label='业务模式' placeholder='请选择业务模式' name='businessMode' onChange={methods.onChangeBusinessMode} />
          </Col>
          {[BusinessMode.Franchisee, BusinessMode.Joint].includes(businessMode) && <Col span={12}>
            <FormFranchisee
              label={franchiseeTitleForMode}
              name='standardFranchiseeId'
              placeholder={`请输入${franchiseeTitleForMode}`}
              createBtnTitle={`去创建${franchiseeShortTitleForMode(businessMode)}`}
              allowClear
              extraParams={{
                businessMode: businessMode,
              }}
            />
          </Col>}
          <Col span={12}>
            <FormFollowingStatus
              disabled={followingStatusDisabled} // 如果是已确定、已开业不能修改
              label='跟进状态'
              placeholder='请选择跟进状态'
              name='followingStatus'
              isEdit/>
          </Col>
          <Col span={12}>
            {isStandardAndClusterBTaskTemplate
              ? <V2FormDatePicker label='期望商圈复核完成时间' name='expectDropInDate' required
                formItemConfig={{
                  getValueFromEvent: (...[, dateString]) => dateString,
                  getValueProps: (value) => ({ value: value ? dayjs(value, 'YYYY-MM-DD') : undefined })
                }} />
              : <V2FormDatePicker label='期望落位日期' name='expectDropInDate'
                formItemConfig={{
                  getValueFromEvent: (...[, dateString]) => dateString,
                  getValueProps: (value) => ({ value: value ? dayjs(value, 'YYYY-MM-DD') : undefined })
                }} />}
          </Col>
          <Col span={12}>
            <FormEmergencyDegree label='紧急度' placeholder='请选择紧急度' name='emergencyDegree'/>
          </Col>
        </Row>
      </V2Form>
    </Modal>
  );
});
export default CircleTaskCreateDrawer;
